// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"15d8a911","107":"02d392d1","133":"eaa05e08","148":"b29f1903","290":"bd39a7c2","511":"c70e7a40"}[chunkId] + ".chunk.js";
};